import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import * as actions from '../../../../../redux/testMode/actions.testMode';
import _ from 'lodash';
import TextareaAutosize from 'react-textarea-autosize';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import cancelEvent from '../../../../../services/mini/cancelEvent';
import { RoundExpandableButton } from '../../../../components/RoundExpandableButton/RoundExpandableButton';
import VisualStateBtn from '../../VisualStateBtn/VisualStateBtn';
import { confirmAlert } from '../../../../../services/mini/alanConfirmAlert';
import AddVisualStateForm from '../../AddVisualStateForm/AddVisualStateForm';
import QrCodePopupForTestMode from '../QrCodePopupForTestMode/QrCodePopupForTestMode';
import store from '../../../../../store';
import getConversationId from '../../../../../services/mini/getConversationId';
import ToasterService from '../../../../../services/ToasterService';

class TestModeBubbleEditor extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            text: '',
            saving: false
        };
        this.textarea = React.createRef();
    }

    componentDidMount() {
        this._isMounted = true;

        if (this.props.autoFocus) {
            this.textarea.current.focus();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onCommand = (e) => {
        const { dialog, conversationId, addDialogItemFromSystemMessage, dialogTree } = this.props;

        addDialogItemFromSystemMessage({
            dialog: dialog || [],
            dialogTree,
            data: e,
            conversationId,
            category: 'command'
        });
    }

    onBeforeMicStart = (e) => {
        this.props.stopAudioInTestMode();
    }

    onChange = (e) => {
        this.setState({ text: e.target.value });
    }

    onKeyDown = (e) => {
        const keyCode = e.keyCode || e.which;
        const { text, saving } = this.state;
        const { isModelActual } = this.props;

        if (saving) {
            cancelEvent(e);
        }

        if (!isModelActual) {
            cancelEvent(e);
        }

        if (keyCode === 13) {
            cancelEvent(e);
            if (text.trim().length > 0) {
                this.send();
            }
        }
    }

    showQrCode = async () => {
        const { dialog, connectQrCodeToTestDialog, generateQrCode } = this.props;
        connectQrCodeToTestDialog({ id: dialog[0].id });
        const qrCodeString = await generateQrCode();
        if (qrCodeString) {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <QrCodePopupForTestMode
                            onClose={onClose}
                            qrCodeString={qrCodeString}
                            store={store} />
                    );
                }
            });
        } else {
            ToasterService.showError({ title: "DialogId is null. Please wait." });
        }
    }

    openVisualStatePanel = () => {
        const { node, direction, dialog, conversationId, addVisualState, dialogTree, onSave } = this.props;
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <AddVisualStateForm
                        onClose={onClose}
                        onSave={(visualState) => {
                            if (onSave) {
                                onSave();
                            }
                            addVisualState({
                                dialog: dialog || [],
                                visualState,
                                curNode: node,
                                conversationId,
                                dialogTree,
                                direction
                            });
                        }}
                    />
                );
            }
        });
    }

    send = () => {
        const {
            dialog,
            node,
            direction,
            conversationId,
            addText,
            dialogTree,
            onSave,
            isModelActual
        } = this.props;

        const { text, saving } = this.state;

        if (!isModelActual) return;
        if (saving) return;

        this.setState({ saving: true }, () => {
            addText({
                dialog: dialog || [],
                dialogTree,
                text,
                curNode: node,
                conversationId,
                direction
            }).then(() => {
                if (!this._isMounted) return;
                this.setState({ text: '', saving: false }, () => {
                    this.props.scrollToLastBubble(this.textarea.current);
                });
            }, () => {
                if (!this._isMounted) return;
                this.setState({ saving: false });
            });
            if (onSave) {
                onSave();
            }
        });

    }

    render() {
        const { text, saving } = this.state;
        const { node, dialog, refreshDialog, actualDialogId } = this.props;
        const hasVisualStatesInDialog = false;
        const isActual = actualDialogId === dialog[0]?.id;

        return (
            <div className={`test-mode-bubble-editor ${saving && 'saving'} ${node && 'in-the-middle'}`}>
                <div className={`test-mode-bubble-editor__placeholder ${text.length === 0 && 'show-placeholder'} ${text && 'filled'}`}>
                    <TextareaAutosize
                        minRows={2}
                        maxRows={15}
                        ref={this.textarea}
                        value={text}
                        onKeyDown={this.onKeyDown}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onChange={this.onChange}
                    />
                </div>

                <div className="test-mode-bubble-editor__actions">
                    <div className="test-mode-bubble-editor__actions-on-left-side">
                        <RoundExpandableButton
                            label="Scan QR"
                            className="debug-chat_qr-code-btn"
                            onClick={this.showQrCode} >
                            <div className="debugging-chat_send-panel_top-btns_qr-code-btn">
                                <i className="icon icon-alan-qr-code-small qr-code-icon" />
                            </div>
                        </RoundExpandableButton>
                        <RoundExpandableButton
                            value={hasVisualStatesInDialog}
                            className="test-mode_vs-btn"
                            label={`${hasVisualStatesInDialog ? 'Edit' : 'Set'} Visual State`}
                            onClick={this.openVisualStatePanel}>
                            <VisualStateBtn visualStatePanelOpened={this.props.visualStatePanelOpened} />
                        </RoundExpandableButton>
                    </div>
                    <RoundExpandableButton
                        label="Send"
                        expanded={text}
                        disabled={!text}
                        saving={saving}
                        className="test-mode_send-btn"
                        onClick={this.send} >
                        <div className={`${text && 'shown'}`}>
                            <i className="icon icon-alan-send" />
                        </div>
                    </RoundExpandableButton>
                </div>
            </div>
        );
    }
}


function mapStateToProps({ testMode, projectsInfo }) {
    return {
        actualDialogId: testMode.actualDialogId,
        isModelActual: projectsInfo.currentProject.isModelActual,
        dialogTree: testMode.dialogTree,
        conversationId: getConversationId(projectsInfo.currentProject.conversations)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateDialogContent: (param) => asyncDispatch(actions.updateDialogContent, dispatch, param),
        addText: (param) => asyncDispatch(actions.addText, dispatch, param),
        generateQrCode: (param) => asyncDispatch(actions.generateQrCode, dispatch, param),
        addDialogItemFromSystemMessage: (param) => asyncDispatch(actions.addDialogItemFromSystemMessage, dispatch, param),
        addVisualState: (param) => asyncDispatch(actions.addVisualState, dispatch, param),
        connectQrCodeToTestDialog: (param) => dispatch(actions.connectQrCodeToTestDialog(param)),
        stopAudioInTestMode: () => dispatch(actions.stopAudioInTestMode()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TestModeBubbleEditor);

